<app-base-modal
  size="standard"
  [title]="contactResourceType.name"
  [showStateToggle]="contactInfoValid()"
  [modalMaxHeight]="'85vh'"
>
  @if (isLoading) {
    <app-loader/>
  }

  @if (contactInfoValid()) {
    <app-current-contacts-modal
      [contactsDialogData]="contactsDialogData"
      [telegramAccountIds]="telegramAccountIds()"
      [isEditModeActive]="isEditModeActive"
      (unbindContact)="handleButtonClick(null)"
      (closeDialog)="closeDialog($event)"
    />
  } @else {
    <app-new-contacts-modal
      [contactsDialogData]="contactsDialogData"
      [telegramAccountIds]="telegramAccountIds()"
      (saveButtonClick)="handleButtonClick($event)"
      (closeDialog)="closeDialog($event)"
    />
  }
</app-base-modal>
